export const CONVERT_SHAPE_TO_SVG_AND_ADD_TO_COLLECTION = "CONVERT_SHAPE_TO_SVG_AND_ADD_TO_COLLECTION";
export const CLEAR_SHAPES_DISPLAY = "CLEAR_SHAPES_DISPLAY";
export const READY_SHAPES_DISPLAY_fOR_SHAPES = "READY_SHAPES_DISPLAY_fOR_SHAPES";
export const ENABLE_SAVE_SHAPE = "ENABLE_SAVE_SHAPE";
export const SET_SHAPE_TO_BE_SAVED = "SET_SHAPE_TO_BE_SAVED";
export const SAVE_SHAPE_TO_SET_OF_SHAPES = "SAVE_SHAPE_TO_SET_OF_SHAPES";
export const REMOVE_SHAPE_FROM_SET_OF_SHAPES = "REMOVE_SHAPE_FROM_SET_OF_SHAPES";   
export const DOWNLOAD_SHAPE = "DOWNLOAD_SHAPE";
export const DELETE_ALL_SHAPES = "DELETE_ALL_SHAPES";

export const CLEAR_CANVAS = "CLEAR_CANVAS";
export const READY_CANVAS_FOR_DRAWING = "READY_CANVAS_FOR_DRAWING";

export const CHANGE_COLOR = "CHANGE_COLOR";